import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Createsubsection from './SubsectionsAdd'
import CustomTable from 'screens/CustomTable/CustomTable'
import { CustomTableColumns } from './SubsectionColumns'
import { useStoreon } from 'storeon/react'

const App = () => {
	const [tableData, setTableData] = useState([])
	const [loading, setLoading] = useState(true)

	const { token } = useStoreon('token')

	// 🔁 Define fetchData outside useEffect so it can be reused
	const fetchData = async () => {
		setLoading(true)
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/getSubSections`,
				{
					headers: {
						Authorization: ` ${token}`
					}
				}
			)
			setTableData(response.data)
		} catch (error) {
			console.error('Error fetching data:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		fetchData() // initial fetch
	}, [])

	return (
		<div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-end',
					alignItems: 'flex-end',
					marginBottom: '10px'
				}}
			>
				<Createsubsection onSuccess={fetchData} />
			</div>

			<div>
				<CustomTable
					tableColumns={CustomTableColumns(fetchData)}
					tableData={tableData}
					loading={loading}
					noDataMessage="No sub sections available"
				/>
			</div>
		</div>
	)
}

export default App
